import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'
import { createPortal } from 'react-dom'

import DDIcon from '../../icons/DDIcon'
import { useReducedMotionPreference, DURATION } from '../../../styles/motion'
import styles from './Toast.module.css'

// Spec §5.11 — transient dark-pill confirmation ("Account number copied", "New code sent"),
// auto-dismisses after 1.8s. Portaled to body so it renders above sheets (z-toast=6 > z-sheet=5).
const Toast = ({ show, message, onDismiss }) => {
  const reduceMotion = useReducedMotionPreference()

  useEffect(() => {
    if (!show) return undefined
    const timer = setTimeout(() => onDismiss?.(), DURATION.toastVisible * 1000)
    return () => clearTimeout(timer)
  }, [show, onDismiss])

  return createPortal(
    <AnimatePresence>
      {show && (
        <motion.div
          role='status'
          aria-live='polite'
          className={styles.toast}
          initial={reduceMotion ? false : { opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? undefined : { opacity: 0, y: 8 }}
          transition={{ duration: DURATION.toastFadeRise }}
        >
          <DDIcon name='verified-fill' />
          <span>{message}</span>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  )
}

Toast.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onDismiss: PropTypes.func,
}

export default Toast
